import { Amplify, Auth } from 'aws-amplify';
import { cognitoPool } from '../../aws-config/index';
import { persistStore } from 'redux-persist';
import { dispatch, store } from 'store';
import { uploadActions } from '../actions/upload.actions';

Amplify.configure({
  ...cognitoPool.auth
});

function login(username, password) {
  return Auth.signIn(username, password)
    .then((response) => response)
    .catch((error) => Promise.reject(error));
}

async function logout(navigate) {
  try {
    await Auth.signOut({ global: true });
    try {
      const persistor = persistStore(store);
      await persistor.purge();
    } catch (persistError) {
      console.warn('Redux Persist purge failed (non-fatal):', persistError);
    }

    localStorage.clear();
    sessionStorage.clear();
    dispatch(uploadActions.logout());
    if ('indexedDB' in window && window.indexedDB.databases) {
      const dbs = await window.indexedDB.databases();
      for (const db of dbs) {
        if (db.name) {
          await window.indexedDB.deleteDatabase(db.name);
        }
      }
    }

    if (navigate) {
      navigate('/login', { replace: true, state: { from: '' } });
    }

    console.log('✅ User fully logged out and storage cleared.');

  } catch (error) {
    console.error('❌ Error during logout:', error);
  }
}

function register(payload) {
  const { email, password } = payload;
  const username = `user_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

  return Auth.signUp({
    username: username,
    password: password,
    attributes: {
      email: email,
      'custom:subscription': 'trial'
    }
  })
    .then((response) => ({
      ...response,
      username,
      email
    }))
    .catch((error) => Promise.reject(error));
}

function otpVerification(record) {
  const { username, code } = record;
  return Auth.confirmSignUp(username, code)
    .then((response) => response)
    .catch((error) => Promise.reject(error));
}

function forgotPassword(email) {
  return Auth.forgotPassword(email)
    .then((response) => response)
    .catch((error) => Promise.reject(error));
}

function forgotPasswordSubmit(username, code, password) {
  return Auth.forgotPasswordSubmit(username, code, password)
    .then((response) => response)
    .catch((error) => Promise.reject(error));
}

function resendOTP(username) {
  return Auth.resendSignUp(username)
    .then((response) => response)
    .catch((error) => Promise.reject(error));
}

export const sessionService = {
  login,
  logout,
  register,
  forgotPassword,
  forgotPasswordSubmit,
  otpVerification,
  resendOTP
};
